// extracted by mini-css-extract-plugin
export default {"leftSidebarStyle":"LeftSidebar_leftSidebarStyle__7L0RG","menuClosed":"LeftSidebar_menuClosed__ktR43","menuClosedNested":"LeftSidebar_menuClosedNested__PZA7e"};